import { ClipboardCheck, FileDown, Grid3X3 } from "lucide-react";

interface BottomNavProps {
  current: "rooms" | "review" | "export";
  onNavigate: (path: string) => void;
}

export function BottomNav({ current, onNavigate }: BottomNavProps): JSX.Element {
  return (
    <nav className="bottom-nav" aria-label="Report navigation">
      <div className="bottom-nav__inner">
        <button
          type="button"
          aria-current={current === "rooms" ? "page" : undefined}
          onClick={() => onNavigate("/rooms")}
        >
          <Grid3X3 size={20} aria-hidden="true" />
          Rooms
        </button>
        <button
          type="button"
          aria-current={current === "review" ? "page" : undefined}
          onClick={() => onNavigate("/review")}
        >
          <ClipboardCheck size={20} aria-hidden="true" />
          Review
        </button>
        <button
          type="button"
          aria-current={current === "export" ? "page" : undefined}
          onClick={() => onNavigate("/export")}
        >
          <FileDown size={20} aria-hidden="true" />
          Export
        </button>
      </div>
    </nav>
  );
}
